export async function $open() {
  return await this.$children[0].open()
}

export const SCROLLABLE_SELECTOR = '.base-modal__body, .base-modal__body *'
